var map = {
	"./en/exchange.png": "JbB+",
	"./ja/exchange.png": "npO/",
	"./ko/exchange.png": "mwpg",
	"./zh-CN/exchange.png": "gWqF",
	"./zh-TW/exchange.png": "hhzJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fUsU";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/exchange\.png$
// module id = fUsU
// module chunks = 1